'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var bgImages = {
  dark: 'url("data:image/svg+xml,%3Csvg%20xmlns=%22http://www.w3.org/2000/svg%22%20viewBox=%220%200%20200%20200%22%3E%3Cg%3E%3Cpath%20fill=%22#777%22%20d=%22M0%200h100v100H0zm100%20100h100v100H100z%22/%3E%3Cpath%20fill=%22#555%22%20d=%22M100%200h100v100H100zM0%20100h100v100H0z%22/%3E%3C/g%3E%3C/svg%3E")',
  light: 'url("data:image/svg+xml,%3Csvg%20xmlns=%22http://www.w3.org/2000/svg%22%20viewBox=%220%200%20200%20200%22%3E%3Cg%3E%3Cpath%20fill=%22#eee%22%20d=%22M0%200h100v100H0zm100%20100h100v100H100z%22/%3E%3Cpath%20fill=%22#fff%22%20d=%22M100%200h100v100H100zM0%20100h100v100H0z%22/%3E%3C/g%3E%3C/svg%3E")',
  none: 'none'
};
var bgColors = {
  dark: 'black',
  light: 'white',
  none: 'transparent'
};

var style = {
  backgroundSize: '20px 20px',
  overflow: 'hidden',
  marginBottom: '10px',
  borderStyle: 'solid',
  borderColor: '#ddd'
};
var styleControlsSide = {
  float: 'left',
  borderRight: 'solid 1px #ddd',
  boxSizing: 'border-box',
  width: '280px'
};
var styleComponentSide = {
  marginLeft: '280px'
};
var styleControlsBottom = {
  borderTop: 'solid 1px #ddd'
};
var styleComponentTop = {};

exports['default'] = _createReactClass2['default']({

  displayName: 'Demo.Layout',

  propTypes: {
    fullWidth: _propTypes2['default'].bool.isRequired,
    panelBelow: _propTypes2['default'].bool,
    controlsEl: _propTypes2['default'].node.isRequired,
    targetEl: _propTypes2['default'].node.isRequired,
    background: _propTypes2['default'].oneOf(Object.keys(bgImages)).isRequired
  },

  getTagretStyle: function getTagretStyle() {
    var fullWidth = this.props.fullWidth;

    return _extends({}, fullWidth ? styleComponentTop : styleComponentSide, {
      padding: !fullWidth ? '1em' : '1em 0'
    });
  },

  getWrapStyle: function getWrapStyle() {
    var _props = this.props;
    var fullWidth = _props.fullWidth;
    var background = _props.background;

    return _extends({}, style, {
      borderWidth: fullWidth ? '1px 0' : '1px',
      backgroundImage: bgImages[background],
      backgroundColor: bgColors[background]
    });
  },

  getControlsStyle: function getControlsStyle() {
    return this.props.fullWidth ? styleControlsBottom : styleControlsSide;
  },

  render: function render() {
    var _props2 = this.props;
    var controlsEl = _props2.controlsEl;
    var targetEl = _props2.targetEl;
    var fullWidth = _props2.fullWidth;

    var demo = _react2['default'].createElement(
      'div',
      { style: this.getTagretStyle(), className: 'react-demo__target-wrap', key: 'demo' },
      targetEl
    );
    var panel = _react2['default'].createElement(
      'div',
      { style: this.getControlsStyle(), className: 'react-demo__controls-wrap', key: 'panel' },
      controlsEl
    );
    return _react2['default'].createElement(
      'div',
      { style: this.getWrapStyle(), className: 'react-demo' },
      fullWidth ? [demo, panel] : [panel, demo]
    );
  }

});
module.exports = exports['default'];